import { type App } from 'vue';
import type Config from '../config';

export interface ConfigOptions {
  config: Config;
}

export default {
  install: (app: App, options: ConfigOptions) => {
    app.config.globalProperties.$config = Object.freeze({ ...options.config });
    app.provide('config', { ...options.config });
  },
};
